import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentVerificationLinkComponent } from './student-verification-link/student-verification-link.component';
import { StudentVerificationComponent } from './student-verification/student-verification.component';

const routes: Routes = [
   {
            path:'',component:StudentVerificationLinkComponent,
            children:[
              {
                path:"studentHTNoVerification", component:StudentVerificationComponent
              },  
            ]
          }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentVerificationRoutingModule { }
